import { useState, useEffect } from 'react';
import { useNetwork } from 'wagmi';
import { Network } from '@kattana-io/common';
import SmallCurrencyIcon from '../../Trading/common/SmallCurrencyIcon';
import { switchCurrentTicker } from '../../../Authlogic';
import './styles.scss';

interface ILeverageModalProps {
  actionCloseModal: () => void;
}

const header = 'Leverage custom trading workflows';
const description = 'This feature is not available in your pricing plan';

const LeverageModal = (props: ILeverageModalProps) => {
  const [network, setNetwork] = useState<Network | undefined>(
    Network.fromChainId(1)
  );
  const { chain } = useNetwork();

  const ktnAmount = 130;

  useEffect(() => {
    if (chain?.id != network?.toDecimal()) {
      setNetwork(Network.fromChainId(chain?.id));
    }
  }, [chain]);

  const { actionCloseModal } = props;

  const buyKTN = () => {
    if (network) {
      if (network.isBSC()) {
        switchCurrentTicker({
          exchange: 'pancakeswap',
          name: 'KTN/WBNB',
        });
        actionCloseModal();
      } else {
        switchCurrentTicker({
          exchange: 'uniswap',
          name: 'KTN/WETH',
        });
        actionCloseModal();
      }
    }
  };

  return (
    <div className='upgradeModal'>
      <div className='upgradeModal__close' onClick={actionCloseModal} />
      <div className='upgradeModal__header'>{header}</div>
      <div className='upgradeModal__description'>{description}</div>
      <div className='upgradeModal__button' onClick={buyKTN}>
        <SmallCurrencyIcon
          network={Network.fromChain('ETH') as any}
          className='upgradeModal__button__icon'
          currency='KTN'
          contract='0x491e136ff7ff03e6ab097e54734697bb5802fc1c'
          variant='s'
        />
        <div className='upgradeModal__button__text'>Buy {ktnAmount} KTN</div>
      </div>
    </div>
  );
};

export default LeverageModal;
